<script>
export default {
name: "DriverDetailsChatCard",
props: {
    driver: {
        type: Object,
        default: null
    },
    rideTypes: {
        type: Array,
        default: null
    }
 },
 methods: {
   startChat () {
       this.$emit('initChat', this.driver)
   },
     driverChannelSelected(channel) {
         this.$store.commit('messaging/setSelectedDriverChannel', channel)
     },
 },
 computed: {
    rideType () {
        return this.rideTypes.find(rideType => {
            return rideType.id == this.driver.ride_type_id
        })
    }
 }
}
</script>

<template>
    <v-card
        v-if="driver != null"
        class="mx-auto"
        max-width="344"
    >
        <v-card-text class="py-0 pt-2">
            <div class="black--text">{{ driver.name }}</div>
            <v-rating
                x-small
                hover
                length="5"
                size="50"
                :value="driver.rating"
            ></v-rating>
            <p >
                <v-icon x-small>mdi-card-account-details-outline</v-icon>
                {{ driver.council }}
            </p>
            <div class="black--text" v-if="rideType">
                <v-icon x-small>mdi-car-outline</v-icon>
                {{ rideType.name }}
            </div>
        </v-card-text>
        <v-card-actions class="py-0 pb-1">
            <v-btn
                x-small
                text
                color="teal accent-4"
                @click="startChat"
            >
                Start Chat
            </v-btn>
        </v-card-actions>
        </v-card>
</template>

<style scoped lang="scss">

</style>